import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

export const LPLink: React.FC<{
  url: string;
}> = ({ url }) => {
  const { t } = useTranslation();
  return (
    <LPLinkWrapper>
      <a href={url} rel="noopener noreferrer" target="_blank">
        {t('ui.link.forMoreInfo')}
      </a>
      <Icon name="external" className="external-link-icon" />
    </LPLinkWrapper>
  );
};

const LPLinkWrapper = styled.div`
  margin-top: 16px;
  color: #2185d0;
  text-decoration: underline;
  .external-link-icon {
    padding-left: 12px;
  }
  margin-bottom: 32px;
`;
